export default {
  data: {
    appName: 'CALL CENTER',
    info: {
      visible: false,
      text: ''
    }
  }
}
